import React from "react";
import { Frame } from "@shopify/polaris";
import Header from "./Header";
import OnboardingProgressBanner from "./OnboardingProgressBanner";
import PinAppBanner, { usePinAppBanner } from "./PinAppBanner";
import ChatbotBetaBanner from "../chatbot/ChatbotBetaBanner";
import ImpersonationBanner from "../UI/ImpersonationBanner";

/*
 * Own component so job-status polling re-renders this slot only.
 * PageLayout does not subscribe, so the page under it does not re-render
 * on every sync poll.
 *
 * Beside: card is the end of whichever bar is in the slot
 * (onboarding, historical, location-switch, or Incoming Inventory).
 * Compact: that strip returned nothing, so the card is its own row and
 * still takes height above the page title.
 */
const PinAppBannerSlot = () => {
  const { placement, dismiss, markPinned } = usePinAppBanner();

  return (
    <>
      <OnboardingProgressBanner
        endSlot={
          placement === "beside" ? (
            <PinAppBanner onClose={dismiss} onAlreadyPinned={markPinned} />
          ) : null
        }
      />
      {placement === "compact" ? (
        <PinAppBanner
          layout="compact"
          onClose={dismiss}
          onAlreadyPinned={markPinned}
        />
      ) : null}
    </>
  );
};

const PageLayout = (props) => {
  /*
   * Header is no longer shown as a visual top bar — logo and avatar are
   * redundant with Shopify admin chrome. We still mount <Header /> (visually
   * hidden) because it owns location-switch regen-status polling and the
   * location-switch-failed Toast. Hiding it with `display: none` keeps that
   * logic working without reserving vertical space.
   *
   * Onboarding/historical import progress lives in OnboardingProgressBanner,
   * a content child of Frame (not Frame's `topBar` prop). Passing `topBar`
   * makes Polaris add `hasTopBar` and reserve a fixed 3.5rem (56px) even
   * when the bar is empty. The banner renders null when sync is done.
   * The pin tip, when it is due, still sits in that same slot in normal
   * flow so it stays above the page title.
   */
  return (
    <Frame>
      <div style={{ display: "none" }} aria-hidden="true">
        <Header />
      </div>
      <ImpersonationBanner />
      <PinAppBannerSlot />
      <ChatbotBetaBanner />
      {props.children}
    </Frame>
  );
};

export default PageLayout;
